// FETCH ALL ACCESSORIES_PO INWARD
export const FETCH_ACCESSORIES_PO_INWARD_MASTER_REQUEST = 'FETCH_ACCESSORIES_PO_INWARD_MASTER_REQUEST';
export const FETCH_ACCESSORIES_PO_INWARD_MASTER_SUCCESS = 'FETCH_ACCESSORIES_PO_INWARD_MASTER_SUCCESS';
export const FETCH_ACCESSORIES_PO_INWARD_MASTER_FAILURE = 'FETCH_ACCESSORIES_PO_INWARD_MASTER_FAILURE';

// CREATE ACCESSORIES_PO INWARD
export const CREATE_ACCESSORIES_PO_INWARD_MASTER_REQUEST = 'CREATE_ACCESSORIES_PO_INWARD_MASTER_REQUEST';
export const CREATE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS = 'CREATE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS';
export const CREATE_ACCESSORIES_PO_INWARD_MASTER_FAILURE = 'CREATE_ACCESSORIES_PO_INWARD_MASTER_FAILURE';

// UPDATE ACCESSORIES_PO INWARD
export const UPDATE_ACCESSORIES_PO_INWARD_MASTER_REQUEST = 'UPDATE_ACCESSORIES_PO_INWARD_MASTER_REQUEST';
export const UPDATE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS = 'UPDATE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS';
export const UPDATE_ACCESSORIES_PO_INWARD_MASTER_FAILURE = 'UPDATE_ACCESSORIES_PO_INWARD_MASTER_FAILURE';

// FETCH SINGLE STATE OF ACCESSORIES_PO INWARD
export const FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_REQUEST = 'FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_REQUEST';
export const FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS = 'FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS';
export const FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_FAILURE = 'FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_FAILURE';

// DELETE ACCESSORIES_PO INWARD
export const DELETE_ACCESSORIES_PO_INWARD_MASTER_REQUEST = 'DELETE_ACCESSORIES_PO_INWARD_MASTER_REQUEST';
export const DELETE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS = 'DELETE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS';
export const DELETE_ACCESSORIES_PO_INWARD_MASTER_FAILURE = 'DELETE_ACCESSORIES_PO_INWARD_MASTER_FAILURE';

export const FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_FAILURE';

export const RESET_ACCESSORIES_PO_INWARD_MASTER_INFO = 'RESET_ACCESSORIES_PO_INWARD_MASTER_INFO';

export const CREATE_ACCESSORIES_PO_INWARD_MASTER_FORM = 'CREATE_ACCESSORIES_PO_INWARD_MASTER_FORM';

export const UPDATE_ACCESSORIES_PO_INWARD_MASTER_FORM = 'UPDATE_ACCESSORIES_PO_INWARD_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_ACCESSORIES_PO_INWARD_DETAILS = 'NAVIGATE_ACCESSORIES_PO_INWARD_DETAILS';

// NAVIGATE TO ACCESSORIES_PO INWARD COMPONENT
export const NAVIGATE_ACCESSORIES_PO_INWARD_MASTER = 'NAVIGATE_ACCESSORIES_PO_INWARD_MASTER';

export const SET_UNIT_NAME_ACCESSORIES_INWARD = 'SET_UNIT_NAME_ACCESSORIES_INWARD';
export const SET_START_DATE_ACCESSORIES_INWARD = 'SET_START_DATE_ACCESSORIES_INWARD';
export const SET_END_DATE_ACCESSORIES_INWARD = 'SET_END_DATE_ACCESSORIES_INWARD';

export const ACCESSORIES_PO_INWARD_USERFORM_RESET = 'ACCESSORIES_PO_INWARD_USERFORM_RESET';
export const SET_ACTIVE_KEY_ACCESSORIES_PO_INWARD_MASTER = 'SET_ACTIVE_KEY_ACCESSORIES_PO_INWARD_MASTER';
export const SET_PENDING_GRID_NAME_ACCESSORIES_PO_INWARD = 'SET_PENDING_GRID_NAME_ACCESSORIES_PO_INWARD';
export const RESET_FORM_DATA_WITHOUT_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_INWARD_ID';
